import { Spinner } from 'src/viewLayer/components/DesignSystem';

import { LoaderWrapper } from './Loader.styled';

export const Loader = (): JSX.Element => (
  <LoaderWrapper data-testid="Loader">
    <Spinner/>
  </LoaderWrapper>
);
